import { render, staticRenderFns } from "./campClass.vue?vue&type=template&id=2f1619dc&scoped=true"
import script from "./campClass.vue?vue&type=script&lang=js"
export * from "./campClass.vue?vue&type=script&lang=js"
import style0 from "./campClass.vue?vue&type=style&index=0&id=2f1619dc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1619dc",
  null
  
)

export default component.exports